import _objectWithoutProperties from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import classnames from 'classnames';
import immer from 'immer';
import { resizableClass } from './styles';
import { getUidStr } from '../utils/uid';
export default (function (Origin) {
  var _temp;

  return _temp =
  /*#__PURE__*/
  function (_React$Component) {
    _inherits(Resizable, _React$Component);

    var _super = _createSuper2(Resizable);

    function Resizable(props) {
      var _this;

      _classCallCheck(this, Resizable);

      _this = _super.call(this, props);
      _this.resizableId = void 0;
      _this.handlers = void 0;
      _this.active = void 0;
      _this.appended = void 0;
      _this.size = void 0;
      _this.el = void 0;
      _this.state = {
        x: 0,
        y: 0
      };
      _this.resizableId = getUidStr();
      _this.handleMouseUp = _this.handleMouseUp.bind(_assertThisInitialized(_this));
      _this.handleMouseMove = _this.handleMouseMove.bind(_assertThisInitialized(_this));
      return _this;
    }

    _createClass(Resizable, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.appendHandler();
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate() {
        if (this.props.resizable) {
          this.appendHandler();
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        if (this.handlers) {
          this.handlers.forEach(function (action, handler) {
            return handler.removeEventListener('mousedown', action);
          });
        }
      }
    }, {
      key: "getStyle",
      value: function getStyle() {
        var _this$state = this.state,
            x = _this$state.x,
            y = _this$state.y;
        if (!this.size) return undefined;
        return {
          width: this.size.width + x,
          height: this.size.height + y
        };
      }
    }, {
      key: "handleMouseMove",
      value: function handleMouseMove(e) {
        var _this2 = this;

        var x = e.movementX;
        var y = e.movementY;
        if (!this.active) return;
        this.setState(immer(function (draft) {
          x += draft.x;
          y += draft.y;
          if (_this2.active.indexOf('x') >= 0) draft.x = x;
          if (_this2.active.indexOf('y') >= 0) draft.y = y;
        }));
      }
    }, {
      key: "handleMouseDown",
      value: function handleMouseDown(dir) {
        this.active = dir;
        document.addEventListener('mousemove', this.handleMouseMove);
        document.addEventListener('mouseup', this.handleMouseUp);
        document.addEventListener('mouseleave', this.handleMouseUp);
      }
    }, {
      key: "handleMouseUp",
      value: function handleMouseUp() {
        this.active = undefined;
        document.removeEventListener('mousemove', this.handleMouseMove);
        document.removeEventListener('mouseup', this.handleMouseUp);
        document.removeEventListener('mouseleave', this.handleMouseUp);
      }
    }, {
      key: "appendHandler",
      value: function appendHandler() {
        var _this3 = this;

        var resizable = this.props.resizable;
        if (!resizable || this.appended) return;
        this.appended = true;
        this.el = document.querySelector(".".concat(resizableClass(this.resizableId)));
        if (!this.el) return;
        this.size = {
          width: this.el.clientWidth,
          height: this.el.clientHeight
        };
        this.handlers = new Map();
        ['x', 'y', 'xy'].forEach(function (dir) {
          if (typeof resizable === 'string' && resizable !== dir) return;
          var handler = document.createElement('div');

          var action = _this3.handleMouseDown.bind(_this3, dir);

          handler.className = resizableClass('handler', "handler-".concat(dir));
          handler.addEventListener('mousedown', action);

          _this3.el.appendChild(handler);

          _this3.handlers.set(handler, action);
        });
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props = this.props,
            resizable = _this$props.resizable,
            className = _this$props.className,
            style = _this$props.style,
            others = _objectWithoutProperties(_this$props, ["resizable", "className", "style"]);

        if (!resizable) return (
          /*#__PURE__*/
          React.createElement(Origin, this.props)
        );
        var ms = Object.assign({}, style, this.getStyle());
        var mc = classnames(className, resizableClass('_', this.resizableId));
        return (
          /*#__PURE__*/
          React.createElement(Origin, Object.assign({}, others, {
            style: ms,
            className: mc
          }))
        );
      }
    }]);

    return Resizable;
  }(React.Component), _temp;
});